import { ChangeDetectorRef, Component, IterableDiffers, OnDestroy, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Select } from "@ngxs/store";
import { DialogCloseResult, DialogContentBase, DialogRef, DialogService } from "@progress/kendo-angular-dialog";
import { ActionService } from "app/intake/actions/action-service";
import { IntakeState } from "app/_state/intake.state";
import { CedNotificationService } from "ced-ng-library";
import { forkJoin, Observable, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { CorrespondanceService } from "../correspondance-service";
import { PostModel } from "app/_shared/correspondance-module/models/post.model";
import { CorrespondanceModel } from "app/_shared/correspondance-module/models/correspondance.model";
import { GroupResult, groupBy } from "@progress/kendo-data-query";
import { DossierActionsComponent } from "../actions/dossier-actions.component";
import { MDMService } from "app/reusable/mdm.service";
import { IntakeService } from "app/intake/intake-services/intake.service";
import { AttachmentService } from "app/intake/attachments/attachment.service";
import { CorrespondanceAttachemntsComponent } from "../correspondanceAttachments/correspondance-attachments.component";
import { CorrespondanceAttachment } from "app/_shared/correspondance-module/models/CorrespondanceAttachment.model";
import { TranslateService } from "@ngx-translate/core";
import { CORRESPONDANCE_TYPES } from "app/_constants/correspondance-types";
import { AuthenticationService } from "app/_services";
import { EMAIL_ACTIONS } from "app/_constants/emailActions";
import { CORRESPONDANCE_STATUS } from "app/_constants/correspondance-statuses";
import { PureCloudService } from "app/_services/pure-cloud.service";
import { FaxModel } from "app/_shared/correspondance-module/models/faxModel";
import { environment } from "environments/environment";
import { ContactPerson } from "app/_models/contact-person.model";
import { FellowTraveller } from "app/_models/fellow-traveller.model";
import { correspondanceEmails } from "app/_constants/CorrespondanceEmails";
import { CORRESPONDANCE_EMAIL_CATEGORIES } from "app/_constants/correspondance-email-categories";
import { PdfPreviewParamNames } from "app/_constants/pdfPreviewParamNames";
import { CommonService } from "app/reusable/common.service";
@Component({
  selector: 'app-correspondance-details',
  templateUrl: './correspondance-details.component.html',
  styleUrls: ['./correspondance-details.component.scss']
})

export class CorrespondanceDetailsComponent extends DialogContentBase implements OnInit, OnDestroy {

  public correspondanceForm: FormGroup;
  actions: any[] = [];
  @Select(IntakeState.getIntake) getIntake$: Observable<any>;
  correspondanceTypes = [];
  FiltredCorrespondanceTypes =[];
  selectedType = "";
  dossierId = null;
  dossierNumber = null;
  insuree = null;
  parties: FellowTraveller [] = [];
  insureeContactPersons: ContactPerson[] = [];
  selectedCorrespondance = null;
  public buttons: Array<any> = [];
  public data: any[];
  public groupedData =[];
  emailAction: string = null;

  private _subject$: Subject<boolean> = new Subject();
  private _searchSubject$: Subject<boolean> = new Subject();
  selectedAction: any;
  selectedCorrespondanceType = null;
  public selectedTO: any[] = [];
  public selectedCC: any[] = [];
  public selectedAttachments: any[] = [];
  public selectedAttachment;
  attachments: any[] = [];
  public CORRESPONDANCE_TYPES = CORRESPONDANCE_TYPES;
  correspondanceEmails: any[] = correspondanceEmails;
  public EMAIL_ACTIONS = EMAIL_ACTIONS
  userName: string = "";
  defaultMessage: string = "";
  isReadOnly: boolean = false;
  canSend = true;
  isOverviewMessage = false;
  public organizationUnits = [];
  refresh: any;
  public isSending : boolean = false;
  serverUrlSlot3 : string = environment.Services.AlphaURLSlot3;

  constructor(dialog: DialogRef,
    private actionService: ActionService,
    private correspondanceService: CorrespondanceService,
    private cedNotificationService: CedNotificationService,
    private dialogService: DialogService,
    private mdmService: MDMService,
    private intakeService: IntakeService,
    private attachmentService: AttachmentService,
    private translateService: TranslateService,
    private authenticationService: AuthenticationService,
    private pureCloudService: PureCloudService,
    private cd: ChangeDetectorRef,
    differs: IterableDiffers,
    private commonService: CommonService,
    
  ) {
    super(dialog);
    this.refresh = differs.find([]).create(null);
  }

  ngOnInit() {
    this.userName = this.authenticationService.currentUserValue.name;
    this.isReadOnly = this.emailAction == EMAIL_ACTIONS.RESEND;
    this.canSend = this.selectedCorrespondance == null ||
      !this.isReadOnly ||
      (this.isReadOnly && this.selectedCorrespondance.post.postCurrentStatu.ptcsCurrentStatusName != CORRESPONDANCE_STATUS.SENT);
    this.initForm();
    this.setValidators();
    this.populateCorrespondanceDetails();
    if (this.selectedCorrespondance != null) {
      this.populateControls();
    }

  }

  completeAndReset()
  {
    this._searchSubject$.next();
    this._searchSubject$.complete();
    this._searchSubject$ = new Subject();
  }
  populateControls() {
    let subjectPrefix = "";
    let messagePrefix = "\n---------------------------------\n";
    let sentDate = this.selectedCorrespondance.post.postSendDate != null ? this.selectedCorrespondance.post.postSendDate : this.selectedCorrespondance.post.postReceiveDate;
    let html = this.defaultMessage;
    let from = this.selectedCorrespondance.post.postEmailFrom != null ? this.selectedCorrespondance.post.postEmailFrom : "";
    if (this.emailAction == EMAIL_ACTIONS.ADD || this.emailAction == EMAIL_ACTIONS.EDIT || this.emailAction == EMAIL_ACTIONS.RESEND) {
      messagePrefix = "";
      if (EMAIL_ACTIONS.EDIT) {
        html = this.selectedCorrespondance.post.postEmailMessage;
      }
    }
    else {
      html += this.translateService.instant('INTAKE.CORRESPONDANCE.REPLY_HEADER',
        {
          userName: this.userName,
          from: from,
          to: this.selectedCorrespondance.post.postEmailTo,
          subject: this.selectedCorrespondance.post.postEmailSubject,
          oldMessage: this.selectedCorrespondance.post.postEmailMessage,
          sentDate: sentDate
        });

      if (this.emailAction == EMAIL_ACTIONS.REPLY) {
        subjectPrefix = "RE: ";
        this.selectedCorrespondance.post.postEmailTo = this.selectedCorrespondance.post.postEmailFrom;
      }
      if (this.emailAction == EMAIL_ACTIONS.FORWARD) {
        subjectPrefix = "FW: ";
      }
    }

    this.correspondanceForm.controls.correspondanceSubject.setValue(subjectPrefix + this.selectedCorrespondance.post.postEmailSubject);
    
    this.correspondanceForm.controls.correspondanceBody.setValue(html);

    if (this.isOverviewMessage)
      this.populateAdresses();
  }

  onEmailToChange($event) {
    this.cd.detectChanges();
    $event.forEach(el => {
      if(el.fax)
        el.value = el.fax
    });
    this.selectedTO = this.getAddress($event);
  }

  oragnizationUnitsFilterChange(filter) {
    this.cd.detectChanges();
    if(this.selectedType == CORRESPONDANCE_TYPES.FAX && filter.length >= 3)
    {
        this.filterOrganizationUnits(filter);
    }
    else if(filter.length < 3 && this.selectedTO.length == 0 && this.selectedType == CORRESPONDANCE_TYPES.FAX)
      {
        let dataMap = this.organizationUnits.sort((a, b) => a.longName.toLowerCase() > b.longName.toLowerCase() ? 1 : -1);
          dataMap.forEach(el => {
            el['value'] = el['id'];
            el['name'] = el['longName'];
          });
          this.groupedData = [...dataMap];
      }
      else if(this.selectedType == CORRESPONDANCE_TYPES.EMAIL || this.selectedType == CORRESPONDANCE_TYPES.SSP){
      this.getSOSInternalEmailMatches(filter);
      }
  }
  getSOSInternalEmailMatches(partialName)
  {
    this.emptySOSInternationalPreviousEmailSearch();
    this.completeAndReset();

    this.correspondanceService.getSOSInternalEmails(partialName)
    .pipe(takeUntil(this._searchSubject$))
    .subscribe((emailList)=>{

      this.data.push(...emailList.map(contact=>({...contact,category: CORRESPONDANCE_EMAIL_CATEGORIES.INTERNAL_SOS})));
      this.groupedData = groupBy(this.data, [{ field: "category" }]);
      this.cd.detectChanges();
      
    })
  }
  emptySOSInternationalPreviousEmailSearch()
  {
    this.data = this.data.filter(contact=>contact.category != CORRESPONDANCE_EMAIL_CATEGORIES.INTERNAL_SOS);
    this.groupedData = groupBy(this.data, [{ field: "category" }]);
    this.cd.detectChanges();
  }
filterOrganizationUnits(filter){
  let suppliersList = this.getSuppliers();
    if(this.selectedType == CORRESPONDANCE_TYPES.FAX && suppliersList.length > 0)
    {
      if(filter == "" && this.selectedTO.length == 0)
      {
        this.organizationUnits = [];
        suppliersList.forEach(element => {
          filter = filter + "_" + element;
        });

        let getOrganizationUnitsUrl: string = `api/OrganizationUnit/FilterOrganizationUnitsCorrespondanceFax/`+filter;
        this.mdmService
          .getData(getOrganizationUnitsUrl)
          .pipe(takeUntil(this._subject$))
          .subscribe((data: any) => {
            if(data.length > 0)
            {
              this.organizationUnits = data.filter(el =>{ return !!el.fax });
            }        
            let dataMap = this.organizationUnits.sort((a, b) => a.longName.toLowerCase() > b.longName.toLowerCase() ? 1 : -1);
            dataMap.forEach(el => {
              el['value'] = el['id'];
              el['name'] = el['longName'];
            });
            this.groupedData = [...dataMap];
          },
          (error) => {
              this.cedNotificationService.error("NOTIFICATIONS.GET_ORGANIZATION_UNIT");
          });
      }
      else {
        let elements = [];
        this.organizationUnits.forEach(el => {
          if(el.longName.toLowerCase().indexOf(filter.toLowerCase()) != -1)
          {
            el['value'] = el['id'];
            el['name'] = el['longName'];
            elements.push(el);
          }
        });
        if(elements.length > 0)
        {
          this.groupedData = elements;
          this.cd.detectChanges();
        }
        else
          {
            let dataMap = this.organizationUnits.sort((a, b) => a.longName.toLowerCase() > b.longName.toLowerCase() ? 1 : -1);
            dataMap.forEach(el => {
              el['value'] = el['id'];
              el['name'] = el['longName'];
            });
            this.groupedData = [...dataMap];
          }
      }
    }
  }

  ngDoCheck() {
    if(this.selectedType == CORRESPONDANCE_TYPES.FAX)
    {
      const change = this.refresh.diff(this.selectedTO);
      if(change && this.selectedTO.length == 0)
      {
        this.oragnizationUnitsFilterChange("")
      }
    }
  }

  getSuppliers():any[]{
    let suppliers = [];
    this.getIntake$.pipe(takeUntil(this._subject$)).subscribe((result) => {
      result.intake.helpPlans.forEach(el => {
        if(el.hpdSupplierName && !suppliers.includes(el.hpdSupplierName))
        {
            suppliers.push(el.hpdSupplierName);
        }  
        if(el.proformaInvoiceList.length > 0){
          el.proformaInvoiceList.forEach(element => {
            if(element.wolSupplierId && !suppliers.includes(element.wolSupplierId))
            {
                suppliers.push(element.wolSupplierId);
            }
          });
        }
      });
      if(result.intake.rehospitalisation && result.intake.rehospitalisation.supplier && !suppliers.includes(result.intake.rehospitalisation.supplier))
      {
            suppliers.push(result.intake.rehospitalisation.supplier);
      }
    });
    return suppliers;
  }

  onEmailCcChange($event) {
    this.cd.detectChanges();
    this.selectedCC = this.getAddress($event);
  }

  getAddress($event) {
    let adressList: any[] = [];
    $event.forEach(value => {

      if(!value && !value.fax && this.selectedType == CORRESPONDANCE_TYPES.FAX)
      {
        let messageCode = "NOTIFICATIONS.FAX_FORMAT_ERROR";
        let message = this.translateService.instant(messageCode, { value: value.longName });
        this.cedNotificationService.error(
          message
        );
        return;
      }

      if (typeof value != 'string') {
        if (this.validateAdressValue(value.value))
          adressList.push(value);
      }
      else {
        if (this.validateAdressValue(value))
          adressList.push({ name: "Custom", value: value, subcategory: "Custom" });
      }
    });
    return adressList;
  }

  validateAdressValue(value) {
    let regx = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (this.selectedType != CORRESPONDANCE_TYPES.EMAIL && !this.isOverviewMessage) {
      regx = /^[0-9]*$/;
    }
    let result = regx.test(value);
    if (!result) {
      this.cedNotificationService.error("NOTIFICATIONS.EMAIL_FORMAT_ERROR");
    }
    return regx.test(value);
  }

  getEmailAdresses() {
    this.data = [];
    forkJoin([
      this.mdmService.getContractedSupplierAdresses({ dossierId: this.dossierId, contactType: this.selectedType }),
      this.mdmService.getExecutorSupplierAdresses({ dossierId: this.dossierId, contactType: this.selectedType }),
      this.mdmService.getInsurancePoliciesAdresses({ dossierId: this.dossierId, contactType: this.selectedType }),
      this.mdmService.getLocationSupplierEmailAdresses({ dossierId: this.dossierId, contactType: this.selectedType }),
    ])
      .pipe(takeUntil(this._subject$))
      .subscribe((results: any[]) => {
        if (results.length != 0) {

          this.data.push(...results[0].map(contact=>({...contact,category: CORRESPONDANCE_EMAIL_CATEGORIES.CONTRACTED_SUPPLIER})));
          this.data.push(...results[1].map(contact=>({...contact,category: CORRESPONDANCE_EMAIL_CATEGORIES.EXECUTOR_SUPPLIER})));
          this.data.push(...results[2].map(contact=>({...contact,category: CORRESPONDANCE_EMAIL_CATEGORIES.INSURERS})));
          this.data.push(...results[3].map(contact=>({...contact,category: CORRESPONDANCE_EMAIL_CATEGORIES.LOCATIONS})));

          this.getIntake$.first().subscribe((data) => {
            const insuree = data.intake.insuree;
            this.addInsureeAddress(insuree);
            this.addContactPersonAddresses(insuree);
            this.addPartiesAddresses(data.intake.parties);
            this.addRehospitalisationAddresses(data.intake.rehospitalisation);
          })
          this.groupedData = groupBy(this.data, [{ field: "category" }]);

          if (this.selectedCorrespondance != null)
            this.populateAdresses();
        }
      });
  }

  addInsureeAddress(insuree)
  {
    if(insuree.ipaEmail != null){
      this.data.push({category:CORRESPONDANCE_EMAIL_CATEGORIES.INSUREE, 
        name: `${insuree.ipaFirstName} ${insuree.ipaLastName}`, value: insuree.ipaEmail});
    }
  }

  addContactPersonAddresses(insuree)
  {
    if(insuree.ContactPersons.length > 0){
      insuree.ContactPersons.forEach(e=>{
        if(e.cpeEmail != null)
        this.data.push({ name: `${e.cpeFirstName} ${e.cpeLastName}`, 
        value: e.cpeEmail,category:CORRESPONDANCE_EMAIL_CATEGORIES.INSUREE_CONTACT_LIST });
      })
    }
  }
  addPartiesAddresses(parties)
  { 
        parties.forEach(e=>{
        if(e.ftdEmail != null)
        this.data.push({ name: `${e.ftdFirstName} ${e.ftdLastName}`, value: e.ftdEmail,category:CORRESPONDANCE_EMAIL_CATEGORIES.TRAVELLER });
      });    
  }
  addRehospitalisationAddresses(rehospitalisation)
  {
    if(rehospitalisation.email != null){
      this.data.push({category:CORRESPONDANCE_EMAIL_CATEGORIES.REHOSPITALISATION, 
        name: rehospitalisation.supplierName, value: rehospitalisation.email});
    }
  }


  getFromCorrespondanceAdresses(adressList: string) {
    let result = [];
    if (adressList != null && adressList != "") {
      let adresses = adressList.split(',');
      adresses.forEach(element => {
        if (this.validateAdressValue(element)) {
          if (this.data != undefined && this.data.map(c => c.value).indexOf(element) >= 0) {
            result.push(this.data.find(d => d.value == element));
          }
          else {
            result.push({ name: "Custom", value: element, subcategory: "Custom" });
          }
        }
      });
    }
    return result;
  }

  populateAdresses() {
    if (this.selectedCorrespondance != null) {

      if (this.emailAction == EMAIL_ACTIONS.ADD || this.emailAction == EMAIL_ACTIONS.EDIT || this.emailAction == EMAIL_ACTIONS.RESEND) {
        this.selectedTO = this.getFromCorrespondanceAdresses(this.selectedCorrespondance.post.postEmailTo);
      }
      else {
        this.selectedTO = this.getFromCorrespondanceAdresses(this.selectedCorrespondance.post.postEmailFrom);
      }
      this.selectedCC = this.getFromCorrespondanceAdresses(this.selectedCorrespondance.post.postEmailCc);
    }
  }

  correspondanceTypeChange($event) {
    this.selectedType = null;
    if ($event != null) {
      this.selectedTO = [];
      this.selectedCC = [];
      this.selectedType = $event.value;

      this.correspondanceForm.controls.correspondanceSubject.setValidators([Validators.required]);
      this.correspondanceForm.controls.correspondanceSubject.updateValueAndValidity();

      if (this.selectedType == CORRESPONDANCE_TYPES.SMS){
        this.getSmsAdresses();
        this.groupedData = [];
      }
      if (this.selectedType == CORRESPONDANCE_TYPES.EMAIL || this.selectedType == CORRESPONDANCE_TYPES.SSP){
        this.getEmailAdresses();
        this.groupedData = [];
        if(this.emailAction == EMAIL_ACTIONS.ADD && (this.selectedType == CORRESPONDANCE_TYPES.EMAIL))
          {
            this.correspondanceForm.controls.correspondanceSubject.setValue("[" + this.dossierNumber + "]");
          }
        if(this.selectedType == CORRESPONDANCE_TYPES.SSP){
          this.correspondanceForm.controls.correspondanceSubject.setValue("");
        this.correspondanceForm.controls.correspondanceSubject.setValidators([Validators.required, Validators.maxLength(100)]);
        this.correspondanceForm.controls.correspondanceSubject.updateValueAndValidity();
      }
      }
       

      if(this.selectedType == CORRESPONDANCE_TYPES.FAX)
      {
        this.correspondanceForm.controls.correspondanceSubject.clearValidators();
        this.correspondanceForm.controls.correspondanceSubject.updateValueAndValidity();
        this.correspondanceForm.controls.correspondanceBody.clearValidators();
        this.correspondanceForm.controls.correspondanceBody.updateValueAndValidity();
        this.getFaxNumbers();
        this.filterOrganizationUnits("");
      }
      if(this.selectedCorrespondance == null){
        this.setDefaultBody();
        this.groupedData = [];
      }
        
      this.populateAttachments();
    }
    else{
      this.correspondanceForm.controls.correspondanceBody.setValue("");
      this.groupedData = [];
    }
    this.setValidators();
  }
  getSmsAdresses(){
    this.data = [];
    this.data.push({ name: this.insuree.ipaFirstName + " " +  this.insuree.ipaLastName, value: this.insuree.ipaPhoneNumber, subcategory: "Insuree" });
    this.insureeContactPersons.forEach( c => {
      if(c.cpePhoneNumber)
        this.data.push({ name: c.cpeFirstName + " " +  c.cpeLastName, value: c.cpePhoneNumber, subcategory: "Conctact persons" });
    });

    this.parties.forEach( p => {
      if(p.ftdPhoneNumber)
        this.data.push({ name: p.ftdFirstName + " " +  p.ftdLastName, value: p.ftdPhoneNumber, subcategory: "Parties" });
      if(p.ftdPhoneNumber2)
        this.data.push({ name: p.ftdFirstName + " " +  p.ftdLastName, value: p.ftdPhoneNumber2, subcategory: "Parties" });
    });

    this.selectedTO = [this.data[0]];
    this.groupedData = [...groupBy(this.data, [
      { field: "subcategory" },
    ])];

    if (this.selectedCorrespondance != null)
      this.populateAdresses();
  }

  getFaxNumbers(){
    this.data = [];
    this.groupedData = [];
    if(this.selectedCorrespondance){
      this.data.push({ fax:this.selectedCorrespondance.post.postEmailTo });
      this.selectedTO = [this.data[0]];
      this.groupedData = [...groupBy(this.data, [
        { field: "subcategory" },
      ])];

      if (this.selectedCorrespondance != null)
        this.populateAdresses();
    }
  }

  correspondanceAttachmenteChange($event) {
    if ($event != null && this.selectedType == CORRESPONDANCE_TYPES.SMS) {
      this.getSmsBody($event.name);
    }
  }

  getSmsBody(body){
    this.correspondanceForm.controls.correspondanceBody.setValue(body);
  }

  populateCorrespondanceDetails() {
    this.getIntake$.pipe(takeUntil(this._subject$)).subscribe((result) => {
      if (result.intake.dossierId != null) {
        this.dossierId = result.intake.dossierId;
        this.dossierNumber = result.intake.policy.dossierNbr;
        this.correspondanceForm.controls.correspondanceSubject.setValue("[" + result.intake.policy.dossierNbr + "]");
        this.insuree = result.intake.insuree;
        this.parties = result.intake.parties;
        this.insureeContactPersons = result.intake.insuree.ContactPersons;
      }
      else {
        if (this.selectedCorrespondance != null && this.selectedCorrespondance.dossierAction != null) {
          this.dossierId = this.selectedCorrespondance.dossierAction.doaDossierId;
        }
      }
      if (this.isOverviewMessage) {
        this.selectedAttachments = [];
        let attachment = { name: this.selectedCorrespondance.post.postOriginalDocument.documentAttributes.find(x => x.dcaAttributeName == "FileName").dcaAttributeContent, value: this.selectedCorrespondance.post.postOriginalDocument.docId }
        this.selectedAttachments.push(attachment);
      }
      else {
        this.populateAttachments();

        this.correspondanceService
          .getCorrespondanceTypes()
          .pipe(takeUntil(this._subject$))
          .subscribe((data: any) => {
            this.correspondanceTypes = [];
            data.forEach(result => {
              this.correspondanceTypes.push({ id: result.dptId, value: result.dptName });
            });
            this.FiltredCorrespondanceTypes=this.correspondanceTypes.sort((a, b) => a.value.toLowerCase() > b.value.toLowerCase() ? 1 : -1);
            if (this.selectedCorrespondance != null) {
              let type = this.correspondanceTypes.find(x => x.id == this.selectedCorrespondance.dpoPostTypeId)
              this.correspondanceForm.controls.correspondanceType.setValue(type);
              this.correspondanceTypeChange(type);
            }
          },
          (error) => {
            this.cedNotificationService.error("NOTIFICATIONS.GET_CORRESPONDANCE_TYPES");
          });
      }

    });
  }

  handleFilterCorrespondanceType(value) {
    this.FiltredCorrespondanceTypes = this.correspondanceTypes.filter(
      (s) => s.value.toLowerCase().indexOf(value.toLowerCase()) != -1
    );
  }

  populateAttachments(){
    if(this.selectedType != CORRESPONDANCE_TYPES.SMS){
      this.populateOtherAttachments();        
    }
    else{
      this.populateSmsAttachments();
    }    
  }

  populateSmsAttachments(){
    this.attachments = [];
    this.correspondanceService.getSmsBodies()
    .pipe(takeUntil(this._subject$))
      .subscribe((data: any) => {
        data.forEach(r => {
          this.attachments.push({ name: r.spbValue.replace('[Dossiernumber]',this.dossierNumber), value: r.spbId });
        });

        if (this.selectedCorrespondance != null) {
          this.selectedAttachments = [];
          let attachment = this.attachments.find(x => x.value == this.selectedCorrespondance.dpoSmsBodyId);
          this.selectedAttachments.push(attachment);
          this.selectedAttachment = attachment;
        }
        this.cd.detectChanges();
      },
      (error) => {
        this.cedNotificationService.error("NOTIFICATIONS.GET_SMS_BODIES");
      });
  }

  populateOtherAttachments(){
    this.attachments = [];    
    this.attachmentService
          .getByDossierId(this.dossierId)
          .pipe(takeUntil(this._subject$))
          .subscribe((data: any) => {
            this.attachments = data.map(({documentAttributes,datId, docId})=>
            {
              let sharepointFileName = null;
              const sharepointFileAttr = documentAttributes.find(x => x.dcaAttributeName == "SharepointFileName");
              if(sharepointFileAttr)
              {
                sharepointFileName = sharepointFileAttr.dcaAttributeContent;
              }
              return ({name: documentAttributes.find(x => x.dcaAttributeName == "FileName").dcaAttributeContent,
              value:datId, 
              sharepointFileName, documentId: docId})
            
            });        
            
            if (this.selectedCorrespondance != null) {
              this.selectedAttachments = [];
              this.selectedCorrespondance.correspondanceAttachments.forEach(result => {
                let attachment = this.attachments.find(x => x.value == result.catAttachmentId);
                this.selectedAttachments.push(attachment);
                this.selectedAttachment = attachment;
              });
            }
            this.cd.detectChanges();
          },
          (error) => {
            this.cedNotificationService.error("NOTIFICATIONS.GET_ATTACHMENT");
          });
  }

  getDate(date) {
    return this.getLocaleDate(date);
  }

  getLocaleDate(date: Date) {
    if (date != null && (this.isIsoDate(date.toString()) || date.toString().indexOf('GMT') == -1)) {
      return this.intakeService.getLocalDate(date);
    }
    return date;
  }

  isIsoDate(dateStringToCompare) {
    return new Date(dateStringToCompare).toISOString() === dateStringToCompare;
  }
  initForm() {        
    this.correspondanceForm = new FormGroup({
      correspondanceEmailFrom: new FormControl({ textValue: 'ma@sosinternational.nl'}),
      correspondanceMultiTO: new FormControl(),
      correspondanceMultiCC: new FormControl(),
      correspondanceSubject: new FormControl("", Validators.required),
      correspondanceBody: new FormControl("", Validators.required),
      correspondanceType: new FormControl(""),
      correspondanceAction: new FormControl(),
    });
  }
  setDefaultBody(){
    this.defaultMessage = "";
    if(this.selectedType == CORRESPONDANCE_TYPES.EMAIL){
        this.defaultMessage = this.translateService.instant('INTAKE.CORRESPONDANCE.DEFAULT_EMAIL', { userName: this.userName });
      } else if(this.selectedType == CORRESPONDANCE_TYPES.SSP){
        this.defaultMessage = this.translateService.instant('INTAKE.CORRESPONDANCE.DEFAULT_EMAIL_NO_LOGO', { userName: this.userName });
      }
    this.correspondanceForm.controls.correspondanceBody.setValue(this.defaultMessage);
  }

  setValidators() {
    if (this.isOverviewMessage ||
      (this.selectedCorrespondance != null && this.selectedCorrespondance.post.postCurrentStatu.ptcsCurrentStatusCode == CORRESPONDANCE_STATUS.RECIEVED)) {
      this.correspondanceForm.controls.correspondanceAction.clearValidators();
      this.correspondanceForm.controls.correspondanceAction.updateValueAndValidity();
    }
    else {
      this.correspondanceForm.controls.correspondanceAction.setValidators(Validators.required);
      this.correspondanceForm.controls.correspondanceAction.updateValueAndValidity();
    }

    if (this.isOverviewMessage) {
      this.correspondanceForm.controls.correspondanceType.clearValidators();
      this.correspondanceForm.controls.correspondanceType.updateValueAndValidity();
    }
    else {
      this.correspondanceForm.controls.correspondanceType.setValidators(Validators.required);
      this.correspondanceForm.controls.correspondanceType.updateValueAndValidity();
    }
  }

  getCorrespondanceData() {
    let correspondance = new CorrespondanceModel();

    const postType = this.correspondanceForm.controls.correspondanceType.value;
    correspondance.dpoPostTypeId = postType.id;
    correspondance.dpoPostTypeName = postType.value;

    correspondance.dpoActionId = this.selectedAction.doaId;
    correspondance.post = new PostModel();
    if (this.selectedTO.length != 0)
      correspondance.post.postEmailTo = this.selectedTO.map(c => c.value).join();
    else
      correspondance.post.postEmailTo = this.correspondanceForm.controls.correspondanceMultiTO.value;
    if (this.selectedCC.length != 0)
      correspondance.post.postEmailCC = this.selectedCC.map(c => c.value).join();
    else
      correspondance.post.postEmailCC = this.correspondanceForm.controls.correspondanceMultiCC.value;
    if (this.selectedType != null && (this.selectedType == CORRESPONDANCE_TYPES.EMAIL|| this.selectedType == CORRESPONDANCE_TYPES.FAX)) {     
      this.selectedAttachments.forEach(result => {
        let correspondanceAttachment = new CorrespondanceAttachment();
        correspondanceAttachment.catAttachmentId = result.value;
        correspondanceAttachment.sharepointFileName = result.sharepointFileName;
        correspondanceAttachment.documentId = result.documentId;
        correspondance.correspondanceAttachments.push(correspondanceAttachment);
      });
    }else if(this.selectedType != null && (this.selectedType == CORRESPONDANCE_TYPES.SSP))
    {
      if(this.selectedAttachment){
        [this.selectedAttachment].forEach(result => {
          let correspondanceAttachment = new CorrespondanceAttachment();
          correspondanceAttachment.catAttachmentId = result.value;
          correspondanceAttachment.sharepointFileName = result.sharepointFileName;
          correspondanceAttachment.documentId = result.documentId;
          correspondance.correspondanceAttachments.push(correspondanceAttachment);
        });
      }
    }
    if (this.selectedAttachment != null && this.selectedType != null && this.selectedType == CORRESPONDANCE_TYPES.SMS) {
      correspondance.dpoSmsBodyId = this.selectedAttachment.value;
    }
    correspondance.post.postEmailFrom = this.correspondanceForm.controls.correspondanceEmailFrom.value.textValue;
    correspondance.post.postEmailSubject = this.correspondanceForm.controls.correspondanceSubject.value;
    correspondance.post.postEmailMessage = this.recoverLineBreaks(this.correspondanceForm.controls.correspondanceBody.value);
    correspondance.post.postDossierId = this.dossierId;
    return correspondance;
  }
  
  recoverLineBreaks(htmlEmailContent)
  {
    return htmlEmailContent.replaceAll('<p></p>','<p><br></p>'); 
  }
  save() {
    if (this.correspondanceForm.valid) {
      let correspondance = this.getCorrespondanceData();
      this.correspondanceService
        .save(correspondance)
        .pipe(takeUntil(this._subject$)).subscribe((result) => {
          this.cedNotificationService.success("NOTIFICATIONS.CORRESPONDANCE_SAVE_SUCCESS");
          this.dialog.close(Math.random());
        },
        (error) => {
          this.cedNotificationService.error("NOTIFICATIONS.SAVE_CORRESPONDANCE");
        });
    }
    else {
      this.cedNotificationService.error("NOTIFICATIONS.REQUIRED_DATA_MISSING");
    }
  }

  send() {    
    if (this.correspondanceForm.valid) {
      if (this.correspondanceForm.controls.correspondanceType.value.value == this.CORRESPONDANCE_TYPES.EMAIL) {
        this.sendEmail();
        return;
      }
      if (this.correspondanceForm.controls.correspondanceType.value.value == this.CORRESPONDANCE_TYPES.FAX) {
        this.sendFax();
        return;
      }
      if (this.correspondanceForm.controls.correspondanceType.value.value == this.CORRESPONDANCE_TYPES.SMS) {
        this.sendSms();
        return;
      }
    }
    else {
      this.cedNotificationService.error("NOTIFICATIONS.REQUIRED_DATA_MISSING");
    }
  }

  sendFax() {
    if (localStorage.getItem(environment.GenesysTokenName) == null) {
      this.cedNotificationService.error("NOTIFICATIONS.GENESYS_NOT_AUTHENTICATED");
      return;
    }
    let correspondance = this.getCorrespondanceData();
    let faxData = new FaxModel();
    faxData.contentType = "application/pdf";
    faxData.correspondance = correspondance;
    faxData.genesysToken = JSON.parse(localStorage.getItem(environment.GenesysTokenName))['token'];
    this.isSending = true ;
    this.correspondanceService.sendFax(faxData).pipe(takeUntil(this._subject$))
      .subscribe((data: any) => {
        this.isSending = false ;
        this.cedNotificationService.success("NOTIFICATIONS.FAX_SEND_SUCCESS");
        this.dialog.close(Math.random());
      },
      (error)=>{
        this.isSending = false ;
        this.cedNotificationService.warning("NOTIFICATIONS.FAX_SENDING");
      });
  }

  sendSms() {
    let correspondance = this.getCorrespondanceData();
    if(correspondance.post.postEmailTo){
    this.isSending = true ;
    this.correspondanceService.sendSms(correspondance).pipe(takeUntil(this._subject$))
      .subscribe((data: any) => {
        this.isSending = false ;
        this.cedNotificationService.success("NOTIFICATIONS.SMS_SEND_SUCCESS");
        this.dialog.close(Math.random());
      },
      (error)=>{
        this.isSending = false ;
        this.cedNotificationService.warning("NOTIFICATIONS.SMS_SENDING");
      });
    }
    else{
      this.cedNotificationService.error("NOTIFICATIONS.RECEIVER_SHOULD_BE_ADDED")
    }
  }

  getFaxData() {
    return {
      addresses: "",
      documentId: "",
      contentType: "",
      name: "",
      timeZoneOffsetMinutes: 120,
      accessToken: "",
      coverSheet: {
        notes: "",
        locale: ""
      }
    };
  }

  sendEmail() {
    if (this.isOverviewMessage) {
      this.isSending = true ;
      this.correspondanceService
        .reSendCorrespondance(this.selectedCorrespondance)
        .pipe(takeUntil(this._subject$)).subscribe((result) => {
          this.isSending = false ;
          this.cedNotificationService.success("NOTIFICATIONS.CORRESPONDANCE_SEND_SUCCESS");
          this.dialog.close(Math.random());
        },
        (error)=>{
          this.isSending = false ;
          this.cedNotificationService.warning("NOTIFICATIONS.EMAIL_SENDING");
        });
    }
    else {
      let correspondance = this.getCorrespondanceData();
      this.isSending = true ;
      this.correspondanceService
        .sendCorrespondance(correspondance)
        .pipe(takeUntil(this._subject$)).subscribe((result) => {
          this.isSending = false ;
          this.cedNotificationService.success("NOTIFICATIONS.CORRESPONDANCE_SEND_SUCCESS");
          this.dialog.close(Math.random());
        },
        (error)=> {
          this.isSending = false ;
          this.cedNotificationService.warning("NOTIFICATIONS.EMAIL_SENDING");
        });
    }
  }

  cancel(): void {
    this.dialog.close();
  }

  doAction($event) {
    console.log($event);
  }

  openActionsDialog() {
    const dialogRef = this.dialogService.open({
      content: DossierActionsComponent,
      width: "80%"
    });
    dialogRef.content.instance.dataSource = this.actions;
    dialogRef.result.subscribe((result: any) => {
      if (!(result instanceof DialogCloseResult)) {
        this.selectedAction = result;
        this.correspondanceForm.controls.correspondanceAction.setValue(this.selectedAction.doaActionTypeLongName)
      }
    });
  }

  openAttachmentsDialog() {
    const dialogRef = this.dialogService.open({
      content: CorrespondanceAttachemntsComponent,
      width: "80%"
    });
    dialogRef.content.instance.dossierId = this.dossierId;
    dialogRef.result.subscribe((result: any) => {
      if (!(result instanceof DialogCloseResult)) {

      }
    });
  }

  handleSelect(event){
    if(event)
   this.correspondanceForm.controls.correspondanceMultiCC.setValue(event);
  }
  handleSelectedTo(event){
    if(event)
    this.correspondanceForm.controls.correspondanceMultiTO.setValue(event);
  }
    async generatePdf(attachmentName) {
    const newWindow  = window.open("","_blank");
    let GetDossierUrl: string =
    `DossierAttachment/GenratePdf/` + attachmentName;
    const res: any =await this.commonService
    .getData(GetDossierUrl, this.serverUrlSlot3).first().toPromise<any>();
     const pdattachmentPreview = {base64:res.pdf, dossierId:this.dossierId};
     localStorage.setItem(PdfPreviewParamNames.attachments,JSON.stringify(pdattachmentPreview));
     newWindow.location.href = `${window.location.origin}/#/dashboard/home/pdfPreview/${PdfPreviewParamNames.attachments}`;
  }
  ngOnDestroy(): void {
    this._subject$.next();
    this._subject$.complete();
  }
}